import script from "./SubHighlightSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SubHighlightSection.vue?vue&type=script&setup=true&lang=js"

import "./SubHighlightSection.vue?vue&type=style&index=0&id=833be9e4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-833be9e4"]])

export default __exports__